import { OptionTemplate } from "shared/api/middleware-api-client";
import { getProductPageSlug } from "./door";

export const getDoorProductURL = (product: OptionTemplate) => {
  const slug = getProductPageSlug(product.code);
  const doorType = `door=${product.code}`;

  return `/producten/${slug}?${doorType}`;
};
